"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENTITY = void 0;
exports.ENTITY = {
    isOrgRegisteredInUSRequired: false,
};
